import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import ApolloLinkTimeout from 'apollo-link-timeout';
import { RetryLink } from 'apollo-link-retry';

// HTTP LINK
// ================================================
// set up apollo link over http

console.log('process.env.REACT_APP_API_HOST', process.env.REACT_APP_API_HOST);
export const httpLink = new HttpLink({
  uri: !process.env.REACT_APP_API_HOST ? 'http://localhost:3000/graphql' : process.env.REACT_APP_API_HOST, // 'https://heyned.meteorapp.com/graphql',
});

console.log(!process.env.REACT_APP_API_HOST ? 'http://localhost:3000/graphql' : process.env.REACT_APP_API_HOST);

// AUTH MIDDLEWARE
// ================================================
// add some middleware for adding auth to headers
export const authLink = new ApolloLink((operation, forward) => {
  const token = window.localStorage['Meteor.loginToken']; // from local storage

  operation.setContext(() => ({
    headers: {
      'meteor-login-token': token,
    },
  }));

  return forward(operation);
});

// ERROR MIDDLEWARE
// ================================================
// add some middleware for catching errors going through graphql layer
export const errorLink = onError(({ graphQLErrors, networkError }) => {
  // if we have graphQLErrors, just console.log them
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => console.log({ message, locations, path }));
  }
});

// RETRY LINK
// ================================================
// see: https://stackoverflow.com/questions/50965347/how-to-execute-an-async-fetch-request-and-then-retry-last-failed-request/51321068#51321068
// and see: https://github.com/apollographql/apollo-link/issues/297#issuecomment-375863699
// set up apollo retryLink to retry on expired token error

// retry will grab token from local storage and hit a refresh token endpoint to attempt to refresh the token

export const retryLink = new RetryLink({
  delay: {
    initial: 0,
  },
  attempts: {
    max: 2,
    retryIf: error => {
      console.log(`========================> retry ran with error code ${error.statusCode}`);
      return false;
    },
  },
});

// TIMEOUT LINK
// ================================================
// NOTE: if you want batch http needs to be turned on server-side: https://github.com/graphql-python/graphene-django/issues/215
// const httpLink = new BatchHttpLink({ uri: '/graphql', credentials: 'include' });
export const timeoutLink = new ApolloLinkTimeout(20000); // 20 second timeout



// WEBPACK FOOTER //
// ./src/ApolloClient/links.js